import Vue from "vue";
import store from "../store";
import { get_error_message } from "@/auth/messages";

var ENDPOINTS = {
  save_raw_json: "save",
  get_raw_json: "get",
  generate_form: "generate",
  creditors_autocomplete: "creditors/autocomplete",
  get_list_of_forms: "forms/list",
  generate_reason: "generate_reason",
  create_client: "clients/create",
  list_clients: "clients/list"
};

export class Backend {
  constructor(config) {
    this.api_url = config.api_url;
    this.stage = config.stage;
  }

  get_endpoint(name) {
    return `${this.api_url}/${this.stage}/${ENDPOINTS[name]}/`;
  }

  async save_raw_json(config, model, step_id, access_token, pesel) {
    var endpoint = this.get_endpoint("save_raw_json");

    var data = {
      config: config,
      model: model,
      step_id: step_id,
      pesel: pesel
    };

    var post_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };

    let result = await Vue.axios(post_data);
    return result;
  }

  async get_raw_json(config, access_token, pesel) {
    var endpoint = this.get_endpoint("get_raw_json");

    var data = {
      config: config,
      pesel: pesel
    };

    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };
    let result;
    try {
      result = await Vue.axios(get_data);
    } catch (e) {
      console.log("No Cognito session. Ending user session");
      store.dispatch("user_session_ended");
    }

    return result;
  }

  async generate_form(config, model, step_id, access_token) {
    var endpoint = this.get_endpoint("generate_form");
    var data = {
      config: config,
      model: model,
      step_id: step_id,
      template_name: "template"
    };

    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }

  async autocomplete(searchQuery, creditor_type, access_token) {
    var endpoint = this.get_endpoint("creditors_autocomplete");
    var data = {
      query: searchQuery,
      creditor_type: creditor_type
    };
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }

  async get_list_generated_forms(access_token) {
    var endpoint = this.get_endpoint("get_list_of_forms");

    var get_data = {
      method: "POST",
      url: endpoint,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }

  async generate_reason(model, access_token) {
    var endpoint = this.get_endpoint("generate_reason");
    var data = {
      merge_fields: model
    };

    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }

  async create_client(model, access_token, success_callback, failure_callback) {
    let endpoint = this.get_endpoint("create_client");

    let data = {
      pesel: model.pesel,
      given_name: model.given_name,
      family_name: model.family_name,
      phone_number: model.phone_number
    };

    let post_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };

    await Vue.axios(post_data)
      .then(result => {
        if (result.data.success) {
          success_callback(result);
        } else {
          failure_callback(get_error_message(result.data));
        }
      })
      .catch(error => {
        if (error.response) {
          failure_callback(get_error_message(error.response.data));
        }
      });
  }

  async list_clients(access_token, success_callback, failure_callback) {
    let endpoint = this.get_endpoint("list_clients");

    let post_data = {
      method: "POST",
      url: endpoint,
      headers: {
        Authorization: access_token
      }
    };

    let result = await Vue.axios(post_data);

    if (result.data.success) {
      for (let [index, client_data] of result.data.clients.entries()) {
        // enumerate returned client objects
        client_data.index = index;
        // construct client name
        client_data.client = `${client_data.given_name} ${client_data.family_name}`;
        // construct date in YYYY/MM/DD hh:mm:ss format
        let date = new Date(client_data.timestamp * 1000);
        client_data.date = `${date.getFullYear()}/${leadingZero(
          date.getMonth() + 1
        )}/${leadingZero(date.getDate())} ${leadingZero(
          date.getHours()
        )}:${leadingZero(date.getMinutes())}:${leadingZero(date.getSeconds())}`;
      }
      success_callback(result.data.clients);
    } else {
      failure_callback(get_error_message(result.data));
    }
  }
}

let leadingZero = value => ("0" + value).slice(-2);
